var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarHoverBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2222 10.45H8.5V15.2H13.2222V10.45ZM12.2778 0V1.9H4.72222V0H2.83333V1.9H1.88889C0.840555 1.9 0.00944444 2.755 0.00944444 3.8L0 17.1C0 18.145 0.840555 19 1.88889 19H15.1111C16.15 19 17 18.145 17 17.1V3.8C17 2.755 16.15 1.9 15.1111 1.9H14.1667V0H12.2778ZM15.1111 17.1H1.88889V6.65H15.1111V17.1Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHoverBlue);
export default __webpack_public_path__ + "static/media/CalendarHoverBlue.dd9acc79a69675807fce1c7e452d98c7.svg";
export { ForwardRef as ReactComponent };